import {
  FC,
  createElement,
  useCallback,
  useMemo,
} from "react";
import { QuestionDropdownModel, RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "survey-react-ui";
import { SearchDropdownDownshift } from "../ui/search-dropdown-downshift";

interface DropdownQuestionProps {
  isDisplayMode: boolean;
  question: QuestionDropdownModel;
}

const SearchDropdownQuestion: FC<DropdownQuestionProps> = ({
  isDisplayMode,
  question,
}) => {
  const {
    value,
    isReadOnly,
    name,
    allowClear,
    isRequired,
    placeholder,
    otherItem,
    noneItem,
    hasOther,
    hasNone,
    isOtherSelected,
    commentPlaceHolder,
  } = question;

  const isDisabled = useMemo(() => {
    return isReadOnly;
  }, [isReadOnly]);

  /**
   * @description Handle the value change of the dropdown
   */
  const onValueChange = useCallback(
    (newVal: string | undefined) => {
      question.value = newVal;
    },
    [question]
  );

  /**
   * @description Set the comment for the dropdown
   */
  const setComment = useCallback((comment: string) => {
    question.comment = comment;
  }, [question]);

  /**
   * @description Get the items for the dropdown
   */
  const getItems = useMemo(() => {
    const items = question.dataChoices.map(({ title, value }) => ({
      title,
      value,
    }));
    return items;
  }, [question.dataChoices]);

  return (
    <div className="flex flex-col gap-2">
      <SearchDropdownDownshift
        aria-required={question.ariaRequired}
        aria-label={question.ariaLabel}
        aria-invalid={question.ariaInvalid}
        aria-errormessage={question.ariaErrormessage}
        autoComplete={question.autocomplete}
        id={question.inputId}
        items={getItems}
        otherItem={otherItem}
        noneItem={noneItem}
        hasOther={hasOther}
        hasNone={hasNone}
        required={isRequired}
        disabled={isDisabled}
        allowClear={allowClear}
        value={value}
        name={name}
        dense
        isOtherSelected={isOtherSelected}
        commentPlaceHolder={commentPlaceHolder}
        onValueChange={onValueChange}
        placeholder={placeholder}
        defaultValue={question.getDefaultValue()}
        comment={question.comment}
        onCommentChange={setComment}
      />
    </div>
  );
};

ReactQuestionFactory.Instance.registerQuestion(
  "sv-search-dropdown-question",
  function (props: any) {
    return createElement(SearchDropdownQuestion, props);
  }
);

RendererFactory.Instance.registerRenderer(
  "dropdown",
  "search-dropdown-question",
  "sv-search-dropdown-question"
);